/**
 * Lightweight site header used by the Auth & Account pages.
 * Matches the `glass-header` look of the homepage. Includes the brand
 * plus an AccountLink on the right so users always have a way to flip
 * between login / account / home.
 */
import { Link } from "react-router-dom";
import AccountLink from "./AccountLink";

const SiteHeader = ({ rightSlot = null }) => {
  return (
    <header className="glass-header py-5" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <Link
          to="/"
          className="serif text-2xl tracking-tight text-[#1A1A1A] font-semibold"
          data-testid="site-header-brand"
        >
          theSnugglePrints
        </Link>
        <div className="flex items-center gap-4">
          {rightSlot}
          <AccountLink testIdPrefix="site-header" />
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
